import { api } from '@http/constants';
import fetchWrapper from '@/http/fetchWrapper';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNotification } from '@eye-able/ui';
import type { PolicyResponse } from '@http/queries/useCreatePolicy';
import { toPolicyStatusUpdateBody } from '@http/queries/useUpdatePolicy';
import { useInlineTranslation } from '@/i18n/hooks/useInlineTranslation';

/** Restore an archived policy to active (`PUT /policies` with status `active`). */
export function useUnarchivePolicy() {
  const queryClient = useQueryClient();
  const notification = useNotification();
  const { t } = useInlineTranslation();

  return useMutation({
    mutationFn: (policy: PolicyResponse) =>
      fetchWrapper.put<PolicyResponse>(
        api.policies,
        toPolicyStatusUpdateBody(policy, 'active'),
      ),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [api.policies] });
      notification.success(t('policyRestoredSuccess'));
    },
  });
}
